export default __webpack_public_path__ + "static/media/9_1_1.a480c3c2.png";